import { render } from "./RelatedProduct.vue?vue&type=template&id=6385580b"
import script from "./RelatedProduct.vue?vue&type=script&lang=js"
export * from "./RelatedProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__